import React from 'react';
import NavigationBar from '../components/NavigationBar';
import './Impressum.css';

const Datenschutz = () => {
  return (
    <>
      <NavigationBar />
      <div className="impressum-page">
        <header className="impressum-header">
          <h1>Datenschutzerklärung</h1>
        </header>

        <section className="impressum-section">
          <h2>Allgemeine Hinweise</h2>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
            personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
            Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
            werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
            unserer unter diesem Text aufgeführten Datenschutzerklärung.
          </p>

          <h3>Datenerfassung auf dieser Website</h3>
          <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
          Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser
          Datenschutzerklärung entnehmen.</p>

          <p><strong>Wie erfassen wir Ihre Daten?</strong><br />
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei
          kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
          <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der
          Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten
          (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
          dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.</p>

          <p><strong>Wofür nutzen wir Ihre Daten?</strong><br />
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
          gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>

          <p><strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
          Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem
          ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
          Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit
          für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen
          die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des
          Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
          <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.</p>

          <p><strong>Analyse-Tools und Tools von Drittanbietern</strong><br />
          Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden.
          Das geschieht vor allem mit sogenannten Analyseprogrammen. Detaillierte Informationen
          zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.</p>
        </section>

        <section className="impressum-section">
          <h2>2. Hosting</h2>
          <h3>Host Europe</h3>
          <p>
            Anbieter ist die Host Europe GmbH, Hansestraße 111, 51149 Köln (nachfolgend Host Europe).
            Wenn Sie unsere Website besuchen, erfasst Host Europe verschiedene Logfiles inklusive
            Ihrer IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von Host Europe:{' '}
            <a href="https://www.hosteurope.de/AGB/Datenschutzerklaerung/" target="_blank" rel="noopener noreferrer">
              https://www.hosteurope.de/AGB/Datenschutzerklaerung/
            </a>.
          </p>
          <p>
            Die Verwendung von Host Europe erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten
            Dienstes geschlossen.
          </p>
        </section>

        <section className="impressum-section">
          <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>

          <h3>Datenschutz</h3>
          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
            Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>
          <p>
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation
            per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem
            Zugriff durch Dritte ist nicht möglich.
          </p>

          <h3>Hinweis zur verantwortlichen Stelle</h3>
          <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
          <address>
            Joerg Geissler<br />
            Tölzer Str. 7<br />
            82064 Strasslach-Dingharting<br />
            <br />
            Telefon: <a href="tel:+4917843477531">+49 (0) 1784347753</a><br />
            E-Mail: <a href="mailto:joerg@geissler.com">joerg@geissler.com</a>
          </address>

          <h3>Speicherdauer</h3>
          <p>
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
            wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
            Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen
            oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht,
            sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
            personenbezogenen Daten haben.
          </p>

          <h3>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung</h3>
          <p>
            Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
            personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw.
            Art. 9 Abs. 2 lit. a DSGVO. Die Einwilligung ist jederzeit widerrufbar.
          </p>

          <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
          <p>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich.
            Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit
            der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>

          <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
          <p>
            Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei
            einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts,
            ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
          </p>

          <h3>SSL- bzw. TLS-Verschlüsselung</h3>
          <p>
            Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine
            verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von
            „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>

          <h3>Widerspruch gegen Werbe-E-Mails</h3>
          <p>
            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur
            Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien
            wird hiermit widersprochen.
          </p>
        </section>

        <section className="impressum-section">
          <h2>4. Datenerfassung auf dieser Website</h2>

          <h3>Cookies</h3>
          <p>
            Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete
            und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend
            für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf
            Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch
            gelöscht.
          </p>
          <p>
            Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert
            werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte
            Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim
            Schließen des Browsers aktivieren.
          </p>

          <h3>Server-Log-Dateien</h3>
          <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in Server-Log-Dateien:</p>
          <ul>
            <li>Browsertyp und Browserversion</li>
            <li>verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p>
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
            Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h3>Anfrage per E-Mail oder Telefon</h3>
          <p>
            Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller
            daraus hervorgehenden personenbezogenen Daten zum Zwecke der Bearbeitung Ihres
            Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
            Einwilligung weiter.
          </p>
        </section>

        <section className="impressum-section">
          <h2>5. Soziale Medien</h2>

          <h3>Instagram</h3>
          <p>
            Auf dieser Website sind Funktionen des Dienstes Instagram eingebunden. Diese Funktionen
            werden angeboten durch die Meta Platforms Ireland Limited, Merrion Road, Dublin 4,
            D04 X2K5, Irland.
          </p>
          <p>
            Wenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung zwischen Ihrem
            Endgerät und dem Instagram-Server hergestellt. Die Nutzung dieses Dienstes erfolgt auf
            Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG.
            Die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p>
            Weitere Informationen finden Sie in der Datenschutzerklärung von Instagram:{' '}
            <a href="https://privacycenter.instagram.com/policy/" target="_blank" rel="noopener noreferrer">
              https://privacycenter.instagram.com/policy/
            </a>.
          </p>
        </section>

        <section className="impressum-section">
          <h2>6. Analyse-Tools und Werbung</h2>

          <h3>Google Tag Manager</h3>
          <p>
            Wir setzen den Google Tag Manager ein. Anbieter ist die Google Ireland Limited,
            Gordon House, Barrow Street, Dublin 4, Irland. Der Google Tag Manager ist ein Tool,
            mit dessen Hilfe wir Tracking- oder Statistik-Tools und andere Technologien auf
            unserer Website einbinden können. Der Einsatz erfolgt auf Grundlage von Art. 6
            Abs. 1 lit. f DSGVO.
          </p>

          <h3>Google Analytics</h3>
          <p>
            Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist
            die Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
            Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
            Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p>
            Sie können die Erfassung Ihrer Daten durch Google verhindern durch das Browser-Plugin:{' '}
            <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer">
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>.
          </p>
        </section>

        <section className="impressum-section">
          <h2>7. Plugins und Tools</h2>

          <h3>OpenStreetMap / Leaflet</h3>
          <p>
            Diese Seite nutzt den Open-Source-Kartendienst OpenStreetMap, eingebunden über die
            Leaflet-Bibliothek. Beim Aufruf der Karte werden Kartenkacheln von Servern der
            OpenStreetMap Foundation (OSMF) geladen. Dabei wird Ihre IP-Adresse an die Server
            der OSMF übermittelt. Details entnehmen Sie der Datenschutzerklärung der OSMF:{' '}
            <a href="https://osmfoundation.org/wiki/Privacy_Policy" target="_blank" rel="noopener noreferrer">
              https://osmfoundation.org/wiki/Privacy_Policy
            </a>.
          </p>
          <p>
            Die Nutzung von OpenStreetMap erfolgt im Interesse einer ansprechenden Darstellung
            unserer Online-Angebote auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
          </p>
        </section>

        <section className="impressum-section">
          <h2>Quelle</h2>
          <p>
            Diese Datenschutzerklärung wurde erstellt auf Basis des Datenschutz-Generators von{' '}
            <a href="https://www.rosa-luxemburg-platz.de/" target="_blank" rel="noopener noreferrer">
              https://www.rosa-luxemburg-platz.de/
            </a>.
          </p>
        </section>
      </div>
    </>
  );
};

export default Datenschutz;
